// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Rf1F","emails":"CreateEditClinics_emails__2XwL0","emailTagLabel":"CreateEditClinics_emailTagLabel__1J5aZ"};